import PleaseLoginAstrologer from '../../../components/features/PleaseLoginAstrologer';

const ProtectedRouteAstrologer = ({ children }) => {

    // if (localStorage.getItem('user_type') !== 'astrologer') {
    //     return <PleaseLoginAstrologer />;
    // }

    return children;
};

export default ProtectedRouteAstrologer;